import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
export var getAutocompleteTheme = function getAutocompleteTheme(theme) {
  return ThemeFactory.create({
    menuOffsetY: theme.autocompleteMenuOffsetY
  }, theme);
};